import { IoLogoInstagram, IoLogoLinkedin, IoLogoFacebook } from "react-icons/io5";
import { PiXLogo } from "react-icons/pi";
import {Link} from "react-router-dom";
import { campaign } from "../config/campaign";

export default function MainFooter() {
    return (
        <footer className={'w-full bg-[#0B1911] text-white p-6 md:p-10'}>
            <div className="grid-cols-1 md:grid-cols-3 grid gap-5 border-b pb-8 border-white/10">
                <div className="w-full">
                    <div className="flex flex-row items-center">
                        <p className={'w-20 text-xs font-black uppercase tracking-[0.1em] text-[#F0A93E]'}>Email Us</p>
                        <div className="h-[1px] w-full bg-white/10"></div>
                    </div>
                    <div className="mt-5 text-white/55">info@ishema.rw</div>
                </div>

                <div className="w-full">
                    <div className="flex flex-row items-center">
                        <p className={'w-20 text-xs font-black uppercase tracking-[0.1em] text-[#F0A93E]'}>Call Us</p>
                        <div className="h-[1px] w-full bg-white/10"></div>
                    </div>
                    <div className="mt-5 text-white/55">+250 792 400 474</div>
                </div>

                <div className="w-full">
                    <div className="flex flex-row items-center">
                        <p className={'w-20 text-xs font-black uppercase tracking-[0.1em] text-[#F0A93E]'}>Find Us</p>
                        <div className="h-[1px] w-full bg-white/10"></div>
                    </div>
                    <div className="mt-5 flex flex-row gap-5 justify-start text-xl text-white/55">
                        <IoLogoFacebook/>
                        <PiXLogo/>
                        <IoLogoLinkedin/>
                        <IoLogoInstagram/>
                    </div>
                </div>
            </div>

            <div className="grid-cols-1 mt-5 md:grid-cols-3 grid gap-5 border-b pb-8 border-white/10">
                <div className="w-full">
                    <div className="flex flex-col items-start gap-2 py-2">
                        <img src={campaign.logo} alt={campaign.fullTitle} className={'w-28'}/>
                        <p className={'text-white/55'}>Powered By Ishema Tickets</p>
                    </div>
                </div>

                <div className="w-full">
                    <div className="flex flex-col items-start gap-2 py-2">
                        <p className={'w-28 text-xs font-black uppercase tracking-[0.1em] text-[#F0A93E]'}>Quick Links</p>
                        <div className="flex flex-wrap w-full">
                            <Link to={'/#tickets'} className={'text-white/55 w-1/2 transition hover:text-[#F0A93E]'}>Tickets</Link>
                            <Link to={'/'} className={'text-white/55 w-1/2 transition hover:text-[#F0A93E]'}>Current Show</Link>
                            <Link to={'/tickets'} className={'text-white/55 w-1/2 transition hover:text-[#F0A93E]'}>My Tickets</Link>
                            <Link to={'/contact-us'} className={'text-white/55 w-1/2 transition hover:text-[#F0A93E]'}>Contact</Link>
                        </div>
                    </div>
                </div>

                <div className="w-full">
                    <div className="flex flex-col items-start gap-2 py-2">
                        <p className={'w-32 text-xs font-black uppercase tracking-[0.1em] text-[#F0A93E]'}>Show Rhythm</p>
                        <div className="flex flex-wrap w-full">
                            <p className={'text-white/55 w-1/2'}>{campaign.lineup}</p>
                            <p className={'text-white/55 w-1/2'}>{campaign.cadence}</p>
                            <p className={'text-white/55 w-1/2'}>Hosted by {campaign.host}</p>
                            <p className={'text-white/55 w-1/2'}>Kigali</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-5 text-sm text-white/45">
                @ Ishema Hub Limited 2026
            </div>
        </footer>
    );
}
